import { render, staticRenderFns } from "./Descuento_4.vue?vue&type=template&id=296c2e8e&scoped=true&"
import script from "./Descuento_4.vue?vue&type=script&lang=js&"
export * from "./Descuento_4.vue?vue&type=script&lang=js&"
import style0 from "./Descuento_4.vue?vue&type=style&index=0&id=296c2e8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296c2e8e",
  null
  
)

export default component.exports